import { employeeServiceApi } from "../../app/employeeServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetEmployeeCartDataParams,
  GetEmployeeCartDataResponseType,
} from "../../types/dashboard";

export const dashboardApi = employeeServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeCartData: builder.query<
      GetEmployeeCartDataResponseType,
      GetQueryArgsType<GetEmployeeCartDataParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getEmployeeCartData,
        ...queryArgs,
      }),
    }),
  }),
});

export const { useGetEmployeeCartDataQuery } = dashboardApi;
